import {
  easeInOutSine,
  smoothstep,
  clamp,
  w, h,
  frameN,
  getCanvasSize,
  setupCommon,
  drawCommon,
  make,
} from '../js/common.js';

export function setup() {
	setupCommon();
	textSize(w(0.05));
}

let x1 = 0.0;
let x2 = 3.2;
let x3 = 4.5;
let x4 = 1.9;

export function draw() {
	drawCommon();

	background(100);
	stroke(0, 0, 0, 0.05);
	noFill();

	x1 = x1 + 0.001;
	x2 = x2 + 0.002;
	x3 = x3 + 0.001;
	x4 = x4 + 0.002 - x1 * 0.01;

	for (let i = 0; i < 450; i++) {
		const n = noise(x1, frameN * 0.1, i * 0.001) * 1.0;
		line(w(n), 0, w(n), h(1));
	}

	for (let i = 0; i < 250; i++) {
		const n = noise(x2, frameN * 0.1, i * 0.003) * 0.5 + 0.3;
		line(w(n), 0, w(n), h(1));
	}

	for (let i = 0; i < 450; i++) {
		const n = noise(x3, frameN * 0.1, i * 0.001) + 0.3;
		line(w(n), 0, w(n), h(1));
	}

	for (let i = 0; i < 350; i++) {
		const n = noise(x4, frameN * 0.1, i * 0.005) - 0.2;
		line(w(n), 0, w(n), h(1));
	}

	noStroke();
	fill(0, 0, 100);
	for (let i = 0; i < 10; i++) {

		const n = i / 10
		let ht = n > 0.5 ? easeInOutSine(n * 2) : easeInOutSine(n * 2 - 0.5);
		ht = ht * (0.4 + 0.4 * Math.sin(Math.PI * 2 * frameN * 0.1));

		rect(0, h(n), w(1), h(lerp(ht * 0.1, easeInOutSine(frameN) * 1 / 10, frameN)));
	}

	fill(0, 0, 0, 10);
	if (noise(frameN * 20) > 0.5)
		text("THIS TOOK MORE", w(0.5), h(0.35));
	if (noise(frameN * 20, 0.42) > 0.5)
		text("THAN 10 MINUTES", w(0.5), h(0.65));
}
